import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { JobStatuses } from '../../../types/api/print-job'

export const completedPrintJobsQueryParams: EndpointQueryParameters = {
    filters: {
        jobStatus: {
            $in: [JobStatuses.Completed, JobStatuses.Cancelled, JobStatuses.Printing],
        },
    },
    populate: {
        material_consumptions: {
            populate: {
                material: {
                    populate: {
                        material_type: true,
                    },
                },
                user_audit: {
                    populate: {
                        created_by_permissions_user: true,
                        updated_by_permissions_user: true,
                    },
                },
            },
        },
        shipment: {
            populate: {
                client: true,
                stamp: { populate: ['tube', 'roller'] },
                virtualStamp: true,
                shipment_positions: true,
                additional_jobs: true,
                calculated: true,
                calculatedOnActual: true,
                lacquers: { populate: '*' },
                blankPreviewFiles: true,
            },
        },
        print_job_executors: {
            populate: {
                user: true,
                machine: true,
            },
        },
        print_queue_entries: {
            populate: {
                machine: true,
            },
        },
    },
    sort: ['id:desc'],
}
